import type {
  CheckoutTireEfficiencyFlag,
  TireEfficiencyType,
} from '@packages/gql/generated/shopping/graphql';
import type { TireEfficiencyFlagSpecificProps } from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';

type TireProductToUiType = Record<TireEfficiencyType, TireEfficiencyFlagSpecificProps['type']>;

export const tireProductToUiTypeMap: TireProductToUiType = {
  FUELEFFICIENCY: 'fuelEfficiency',
  WETGRIP: 'wetGrip',
  EXTERNALROLLINGNOISE: 'externalRollingNoise',
};

type TireOrderToUiType = Record<
  CheckoutTireEfficiencyFlag['type'],
  TireEfficiencyFlagSpecificProps['type']
>;

export const tireOrderToUiTypeMap: TireOrderToUiType = {
  FuelEfficiency: 'fuelEfficiency',
  WetGrip: 'wetGrip',
  ExternalRollingNoise: 'externalRollingNoise',
};
